import { useState, useEffect } from 'react';
import { persistenceService } from '../utils/persistenceService';

export const usePasswordProtection = () => {
  const [isAccessGranted, setIsAccessGranted] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const preferences = await persistenceService.getPreferences();
        
        if (preferences.passwordProtection?.granted && preferences.passwordProtection?.grantedAt) {
          const now = Date.now();
          const grantedAt = new Date(preferences.passwordProtection.grantedAt).getTime();
          const sessionDuration = 24 * 60 * 60 * 1000; // 24 hours
          
          if (now - grantedAt < sessionDuration) {
            setIsAccessGranted(true);
          } else {
            // Session expired, revoke access
            await persistenceService.updatePreferences({
              passwordProtection: { granted: false, grantedAt: new Date() }
            });
            setIsAccessGranted(false);
          }
        } else {
          setIsAccessGranted(false);
        }
      } catch (error) {
        console.error('Error checking password protection access:', error);
        setIsAccessGranted(false);
      }
    };

    checkAccess();
  }, []);

  const grantAccess = async () => {
    try {
      const grantedAt = new Date();
      await persistenceService.updatePreferences({
        passwordProtection: { granted: true, grantedAt }
      });
      setIsAccessGranted(true);
    } catch (error) {
      console.error('Error granting access:', error);
      // Fallback to original behavior
      localStorage.setItem('thinkmate_access_granted', 'true');
      localStorage.setItem('thinkmate_access_granted_at', Date.now().toString());
      setIsAccessGranted(true);
    }
  };

  const revokeAccess = async () => {
    try {
      await persistenceService.updatePreferences({
        passwordProtection: { granted: false, grantedAt: new Date() }
      });
      setIsAccessGranted(false);
    } catch (error) {
      console.error('Error revoking access:', error);
      // Fallback to original behavior
      localStorage.removeItem('thinkmate_access_granted');
      localStorage.removeItem('thinkmate_access_granted_at');
      setIsAccessGranted(false);
    }
  };

  return {
    isAccessGranted,
    grantAccess,
    revokeAccess,
  };
}; 